module.exports = __webpack_public_path__ + "img/britishindianoceanterritory.9e536500.svg";